import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toIds } from './values';

export function meals(query: QueryObject): Pick<SearchCriteriaParams, 'meals'> | null {
  const ids = toIds(query.meal);

  return ids.length ? { meals: ids } : null;
}
